import React, { useState } from "react";
import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { IconButton, PrimaryButton } from "@prestosports/commons-ui";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import Close32 from "@carbon/icons-react/lib/close/32";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import emptyMatchStyles from "../styles/EmptyMatch.styles";
import commonStyles from "../../common/styles/Common.styles";
import { useMatchesContext } from "../../../state/matches/context";
import MatchEdit from "./MatchEdit";
import { useEventContext } from "../../../state/events/context";
import { getSafe } from "../../../util/object-util";
import MatchDialogTitle from "./MatchDialogTitle";
import { useAppContext } from "../../../state/app/context";
import matchSettingsStyles from "../styles/MatchSettings.styles";

const EmptyMatch = ({ isSingle }) => {
	const commonClasses = commonStyles();
	const classes = emptyMatchStyles();
	const matchSettingsClasses = matchSettingsStyles();

	const { state: appState } = useAppContext();
	const isSubmitting = appState.isSubmitting();

	const { state: matchState, saveMatch } = useMatchesContext();
	const { state: eventState } = useEventContext();

	const singleMatches = matchState.singles();
	const doubleMatches = matchState.doubles();
	const { gameConfiguration } = eventState.currentEventSettings() || {};

	const [addMatchDialog, setAddMatchDialog] = useState(false);
	const [formData, setFormData] = useState({});

	const handleDialogClose = () => {
		setAddMatchDialog(false);
	};

	const handleSaveMatch = async () => {
		await saveMatch(formData.values);
		handleDialogClose();
	};

	return (
		<div className={classes.container}>
			<Box
				className={classes.box}
				display="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
			>
				<Typography className={classes.question}>
					Do you want to add a new match?
				</Typography>
				<Typography className={matchSettingsClasses.settings} variant="caption">
					Matches Played:
					<span className={matchSettingsClasses.settingValue}>
						{` ${getSafe(() =>
							isSingle
								? `${singleMatches.length}/${gameConfiguration.singles.numberOfMatches}`
								: `${doubleMatches.length}/${gameConfiguration.doubles.numberOfMatches}`
						)}`}
					</span>
				</Typography>

				<PrimaryButton
					disabled={getSafe(() =>
						isSingle
							? singleMatches.length >= gameConfiguration.singles.numberOfMatches
							: doubleMatches.length >= gameConfiguration.doubles.numberOfMatches
					)}
					label={isSingle ? "Add Single Match" : "Add Doubles Match"}
					onClick={() => setAddMatchDialog(true)}
					size="medium"
				/>
			</Box>
			<Dialog
				open={addMatchDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				classes={{ paperWidthSm: classes.paperWidthSm }}
			>
				<DialogTitle id="alert-dialog-title">
					<Box className={commonClasses.textContainer}>
						<MatchDialogTitle match={{ isSingle }} />
					</Box>
					<IconButton
						onClick={handleDialogClose}
						aria-label="close-dialog"
						className={commonClasses.closeButton}
					>
						<Close32 />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<MatchEdit
						onValidate={(values) => setFormData(values)}
						match={{ isSingle }}
						showRank={false}
					/>
				</DialogContent>
				<DialogActions>
					<Button
						disabled={isSubmitting || !formData.isValid || !addMatchDialog}
						onClick={handleSaveMatch}
						color="primary"
					>
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default EmptyMatch;
